/* eslint-disable no-param-reassign */

// eslint-disable-next-line import/no-cycle
import Utils from '../../../../lib/utils';
import LocalStorageUtils from '../../../../lib/localStorageUtils';

export default {
  state: {
    prevTopicBackLink: false,
  },

  getters: {
    prevTopicBackLink: (state) => state.prevTopicBackLink,
  },

  mutations: {
    prevTopicBackLinkUpdate(state, prevTopicBackLink) {
      state.prevTopicBackLink = prevTopicBackLink;
    },
  },

  actions: {
    async handleBackLinkKeywordAndTopicTag({ commit, dispatch }, urlParams) {
      urlParams.faq = false;
      urlParams.searchQuery = false;

      commit('isTopicSelectedFlagUpdate', true, { root: true });
      commit('isSearchQuerySubmittedFlagUpdate', true, { root: true });

      await dispatch('updatePrevItemLink', urlParams);
      dispatch('updateUrlParams', { params: { ...urlParams }, pushHistoryEntryFlag: true }, { root: true });
    },
    async updatePrevItemLink({ rootGetters, commit, dispatch }, urlParams) {
      let prev = {};
      let params = urlParams || rootGetters.urlParams;
      params = Utils.getObjectCopy(params);
      let newUrl = Utils.formatUrlParametersObject(params);

      if ((params.productID || params.identifier || params.focus)
        && (!params.searchQuery || !params.topicTag)) {
        prev.text = `${rootGetters.product.displayName}
                   ${rootGetters.translations.supportCenterResultsPage.scSearchResults.productFlowBackLink}`;
        prev.url = newUrl;
      } else if (params.searchQuery && params.topicTag) {
        params.searchQuery = false;
        newUrl = Utils.formatUrlParametersObject(params);
        prev = await dispatch('getPreviousTopicResultPageBackLink', { newUrl });
      } else {
        prev.text = rootGetters.translations.navigation.scBreadcrumb.noProductTopics;
        // eslint-disable-next-line prefer-destructuring
        prev.url = window.location.href.split('?')[0];
      }

      commit('prevTopicBackLinkUpdate', prev);
    },
    getPreviousTopicResultPageBackLink({ rootGetters }, { newUrl, urlParams }) {
      const prev = {};
      const params = urlParams || rootGetters.urlParams;
      let tagName = rootGetters.getGeneralTagNameFromId(params.topicTag) || false;
      prev.text = '';

      if (params.tab === 'welcome') {
        tagName = rootGetters.translations.scTabs.scWelcomeTab.tabLabel;
        prev.text = rootGetters.product ? `${rootGetters.product.displayName} ${tagName}` : tagName;
      } else if (tagName) {
        prev.text = rootGetters.product ? `${rootGetters.product.displayName} ${tagName}` : tagName;
      } else if (rootGetters.urlParams.faq) {
        prev.text = rootGetters.isInternal ? 'Internal Support Center' : rootGetters.translations.navigation.scBreadcrumb.title;
        // eslint-disable-next-line no-param-reassign
        newUrl = `/${Utils.getLocale()}/`;
      }

      prev.url = newUrl;
      return prev;
    },

    async updateFirstFaqBackLink({ commit, rootGetters, dispatch }, urlParams) {
      let prev = {};
      let params = urlParams || rootGetters.urlParams;
      params = Utils.getObjectCopy(params);
      delete params.faq;

      const newUrl = Utils.formatUrlParametersObject(params);
      const { searchQuery } = rootGetters.urlParams;

      if (rootGetters.urlParams.searchQuery) {
        prev.text = rootGetters.product ? `${rootGetters.product.displayName} ${searchQuery}` : searchQuery;
        prev.url = newUrl;
      } else {
        prev = await dispatch('getPreviousTopicResultPageBackLink', { newUrl, params });
      }

      commit('backLinkResultsUpdate', prev, { root: true });
    },

    pushElementToFaqList({ rootGetters, commit }) {
      const faqList = JSON.parse(LocalStorageUtils.getLocalStorageValue('faqs')) || [];

      if (faqList.length === 10) { // store only last 10 faq's in local storage
        return;
      }
      const faq = {
        url: window.location.href,
        text: rootGetters.faqDetails.title,
        faqId: rootGetters.urlParams.faq,
      };
      faqList.push(faq);
      LocalStorageUtils.setLocalStorageValue('faqs', JSON.stringify(faqList));
      commit('prevFaqUpdate', faq, { root: true });
    },
    getElementFromFaqList({ commit }, deleteElement) {
      try {
        const faqList = JSON.parse(LocalStorageUtils.getLocalStorageValue('faqs'));
        if (faqList && faqList.length > 0) {
          let element;
          if (deleteElement) {
            element = faqList.pop();
          } else {
            element = faqList[faqList.length - 1];
          }
          LocalStorageUtils.setLocalStorageValue('faqs', JSON.stringify(faqList));
          return element;
        }
        commit('prevFaqUpdate', false, { root: true });
        return false;
      } catch (e) {
        return false;
      }
    },
  },
};
